export type PolarisMap = Record<
  DeployEnv,
  {
    namespace: string;
    service: string;
  }
>;

const polaris: PolarisMap = {
  test: {
    namespace: 'Development',
    service: 'trpc.wemeet.gateway.api',
  },
  ci: {
    namespace: 'Test',
    service: 'trpc.wemeet.gateway.api',
  },
  preRelease: {
    namespace: 'Pre-release',
    service: 'trpc.wemeet.gateway.api',
  },
  production: {
    namespace: 'Production',
    service: 'trpc.wemeet.gateway.api',
  },
};

export default polaris;
